import React, { useEffect, useState } from 'react';

import EquifaxAllowAccess from './EquifaxAllowAccess';
import FrozenFileDefault from './FrozenFileDefault';
import { equifaxAllowAccessEnabled } from '../../../../lib/constants/SiteVariables';

export default function FrozenFile({ user, allowAccessToken }) {
  // Remember if we ever had a token to prevent flashing FrozenFileDefault
  // when the token is cleared after successful resubmission
  const [hadToken, setHadToken] = useState(!!allowAccessToken);

  useEffect(() => {
    if (allowAccessToken) {
      setHadToken(true);
    }
  }, [allowAccessToken]);

  if (equifaxAllowAccessEnabled && (allowAccessToken || hadToken)) {
    return (
      <EquifaxAllowAccess user={user} allowAccessToken={allowAccessToken} />
    );
  }

  return <FrozenFileDefault user={user} />;
}
